import { TextMediaBox } from '@models/interfaces';
import { CmsComponentTypeEnum } from '@models/enums';

export namespace ImageLeft {
  export const TypeEnum = CmsComponentTypeEnum.IMAGE_LEFT;

  export interface ComponentConfig extends Omit<TextMediaBox.ComponentConfig, 'media'> {
    media: TextMediaBox.MediaImageConfig;
  }
}
